// BeneAIToolCallCard — BeneAI-02.
//
// Shows that the model is invoking a tool. Read tools render this
// card and immediately follow with a BeneAIToolResultCard; mutating
// tools render this card and follow with a BeneAIConfirmationCard
// (then a BeneAIReceiptCard after the user resolves).

import { Wrench } from "lucide-react";

import type { BeneAIToolUseBlock } from "../types";


export function BeneAIToolCallCard({ block }: { block: BeneAIToolUseBlock }) {
  return (
    <div
      data-testid="beneai-tool-call"
      data-tool-name={block.tool_name}
      className="self-start max-w-[85%] rounded-md border border-border-subtle bg-canvas px-3 py-2 text-xs"
    >
      <div className="flex items-center gap-1.5 text-text-secondary">
        <Wrench size={12} aria-hidden="true" className="text-teal" />
        <span className="font-medium text-text-primary">
          {humanize(block.tool_name)}
        </span>
        <span className="text-text-tertiary">requested</span>
      </div>
    </div>
  );
}


function humanize(toolName: string): string {
  return toolName.replace(/_/g, " ");
}
